import axios from "axios";

type ErrorPayload = {
  message?: string | string[];
  validationMessage?: string | string[];
  error?: string;
  errors?: unknown;
};

const normalizeMessage = (value: unknown): string | null => {
  if (typeof value === "string") return value;

  if (Array.isArray(value)) {
    const values = value
      .map((item) => (typeof item === "string" ? item : null))
      .filter((item): item is string => Boolean(item));

    return values.length > 0 ? values.join(", ") : null;
  }

  return null;
};

export function getErrorMessage(
  error: unknown,
  fallback = "Something went wrong. Please try again.",
): string {
  if (axios.isAxiosError<ErrorPayload>(error)) {
    const data = error.response?.data;

    if (typeof data === "string" && data) {
      return data;
    }

    const directMessage =
      normalizeMessage(data?.validationMessage) ??
      normalizeMessage(data?.message) ??
      normalizeMessage(data?.error);

    if (directMessage) {
      return directMessage;
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallback;
}
